import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setInsuranceCompany } from 'redux/actions';
import { getZppCourseOfferId } from '../utils/getZppCourseOfferId';

export const useHkkBgmContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setInsuranceCompany({
        insuranceCompany: {
          id: '2C4CCA94B046CE2DA355E94366646FDE62B9ABC6B2B49B571D7DF912F1CD6EBFCD880C2D3B681E33',
          name: 'hkk',
          supportEmail: 'hkk@balloonapp.de',
          cooperationLogo: 'https://cdn.balloonapp.de/as/p039rgvo9o0p9m0u.svg',
          cooperationLogoHover: 'https://cdn.balloonapp.de/as/mddqrj2jaa6ll8nn.svg',
          cooperationPartner: true,
          slug: 'hkk-bgm',
          zppCourseOffers: [
            {
              id: '2C4CCA94B046CE2D2BF269966275461CB5FA0E4200E3F6CACE2E60AD5D25C1FF6044D7AD47470FE5695B11EB50E38A1B',
              courseTitle: 'Balloon macht dein Leben leichter',
              slug: 'sda',
              offerId: getZppCourseOfferId('hkkBgm'),
              content: {
                formFieldsAvailable: ['company_name'],
                formFieldsRequired: ['company_name_required'],
                additionalConsentChecks: ['personal_data_condition_accepted'],
                courseinfoChecklist:
                  'Wissenschaftlich fundierte Techniken \r\nfür Anfänger und Fortgeschrittene\r\n\r\n10 Minuten am Tag, im Homeoffice\r\noder unterwegs\r\n\r\nIm Alltag gelassen bleiben\r\nund Stress reduzieren',
                bonusDurationText: 'inkl. 6 Monate Balloon',
                courseinfoDescription:
                  'Balloon sorgt für weniger Stress, besseren Schlaf und mehr Gelassenheit. In der App erwartet dich ein spezieller Kurs für mehr Achtsamkeit. Er ist Teil des Betrieblichen Gesundheitsmanagements der hkk. Die Audio-Einheiten des Kurses begleiten dich Schritt für Schritt in einen entspannteren Alltag.\r\n\r\nDr. Boris Bornemann, promovierter Psychologe und Meditationsforscher, ist Kopf und Stimme der Balloon-App.',
                courseinfoHeadline: 'Balloon macht dein Leben leichter.',
                courseinfoIllustrationUrl: 'https://cdn.balloonapp.de/as/c8glp5jefk8wf1aa.png',

                headerHeadline: 'Deine Reise mit Balloon und der hkk',
                headerLogoUrl: 'https://cdn.balloonapp.de/as/l78jrcqgd48k7fam.svg',
                headerSubline:
                  'Starte jetzt den Kurs "Stressreduktion durch Meditation \u0026 Achtsamkeit" und sichere dir sofort 6 Monate Vollzugriff auf die komplette Balloon Bibliothek.',
                howtoHeadline: 'Kostenlos im Betrieblichen\nGesundheitsmanagement der\nhkk enthalten',
                howtoText1:
                  'Registriere dich auf dieser Seite bei Balloon: Gib deinen Namen, deine E-Mail-Adresse und den Namen deiner Firma an.',
                howtoText2:
                  'Lade dir die Balloon-App herunter und melde dich mit deiner E-Mail-Adresse an. Dein kostenloser Zugriff auf den Kurs "Stressreduktion durch Meditation \u0026 Achtsamkeit" gilt für 6 Monate.',
                howtoText3:
                  'Absolviere den Kurs vollständig, um ein Teilnahmezertifikat zu erhalten. Parallel zum Kurs erhältst du außerdem 6 Monate Vollzugriff auf die gesamte Balloon-App.'
              }
            }
          ]
        }
      })
    );
  }, []);
};
